module.exports = __webpack_public_path__ + "05_glasses_blue.fd1c1606.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer4/05_glasses_blue.png
// module id = KnFI
// module chunks = 0